<ms-common-turn-form [isPatch]="isPatch" [isPatchDoctor]="isPatchDoctor" [isPatchStatus]="isPatchStatus"
  [isAgenda]="false" [turnId]="turnId" [patientHelp]="patientHelp" [specialty]="specialty"
  [specialtyCodeAlt]="specialtyCodeAlt" (saveSubscribe)="saveSubscribe($event)">
</ms-common-turn-form>